import React, { useState, useEffect, useRef } from 'react';
import { setSingleWdataTal, setSingleWdataBerge, setMultiWdataTal, setMultiWdataBerge, setActiveTab} from '../../actions/wetterAction';
import getWeatherForcast from '../api/weather';
import TopSection from '../TopSection';
import MiddleSection from '../MiddleSection';
import BottomSection from '../BottomSection';
import {MODIMAGEPATH} from '../api';
import Slider from "react-slick";
import { useDispatch, useSelector } from 'react-redux';
import Language from './../../language/language.json';

function TnWetterBig(props) {
    const dispatch = useDispatch();
    const wintermonths = [10,11,0,1,2];
    const isWinter = wintermonths.includes(new Date().getMonth());
    useEffect(() => {
        document.documentElement.style.setProperty('--widget-textcolor', props.textcolor);
        document.documentElement.style.setProperty('--widget-bgimage', 'url('+(isWinter && props.bgimagewinter !== "" ? props.bgimagewinter : props.bgimage)+')');
        document.documentElement.style.setProperty('--widget-bgopacity', props.bgopacity+'%');
        if(props.acclat !== "" && props.acclon !== ""){
            var singleday_requestT = {lat: props.acclat, lon: props.acclon, lang: props.lang, v: 'plugin1', extra: 'tempU=c&linU=m&windU=ms'}
            getWeatherForcast(singleday_requestT).then((data) => {
                dispatch(setSingleWdataTal(data));
            });

            var multiday_requestT = {lat: props.acclat, lon: props.acclon, lang: props.lang}
            getWeatherForcast(multiday_requestT).then((data) => {
                dispatch(setMultiWdataTal(data));
            });
        }

        if(props.berglat !== "" && props.berglon !== ""){
            var singleday_requestB = {lat: props.berglat, lon: props.berglon, lang: props.lang, v: 'plugin1', extra: 'tempU=c&linU=m&windU=ms'}
            getWeatherForcast(singleday_requestB).then((data) => {
                dispatch(setSingleWdataBerge(data));
            });

            var multiday_requestB = {lat: props.berglat, lon: props.berglon, lang: props.lang}
            getWeatherForcast(multiday_requestB).then((data) => {
                dispatch(setMultiWdataBerge(data));
            });
        }
    }, [])
    console.log("render tn-wetter-big");
    return (
        <div className='tn-wetter-big-container'>
            <div className='section_top_bg'>
                <div className='weather_bg_overlay'></div>
                <div className='section_top'>
                    <TopSection {...props}></TopSection>
                </div>
            </div>
            <div className='section_two'>
                <MiddleSection {...props}></MiddleSection>
            </div>
            <div className="section_bottom">
                <BottomSection {...props}></BottomSection>
            </div>
        </div>
    )
}

export default TnWetterBig;
